import axios from 'axios';
import { API } from '../config';

// Fetcher toponomastica per lo STAFF desktop (autocomplete indirizzo TIM come l'agente PWA),
// usa gli endpoint /toponomastica/* con l'auth dell'app. Niente reverseGeo (no geoloc su desktop).
const staffTopoFetcher = {
  comuni: (q) => axios.get(`${API}/toponomastica/comuni`, { params: { q } }).then((r) => r.data.items),
  vie: (q, cp, cc) => axios.get(`${API}/toponomastica/vie`, { params: { q, codProv: cp, codCom: cc } }).then((r) => r.data.items),
  civici: (cfv) => axios.get(`${API}/toponomastica/civici`, { params: { codForteVia: cfv } }).then((r) => r.data.items),
};

export default staffTopoFetcher;
